module.exports = __webpack_public_path__ + "img/medecine-check-wotc.1ed5b36d.jpg";